export * from './root.js'
export * from './canvas.js'
export * from './component.js'
export * from './tabs.js'
export * from './windows.js'
export * from './data.js'
export * from './design-system.js'
export * from './modal.js'
export * from './db.js'
export * from './code.js'
export * from './project.js'
export * from './renderer-shared.js'
export * from './renderer-canvas.js'
// `./renderer-component` was removed 2026-07-27. Its single export,
// `renderStateComponentDashboard`, imported `createEmotion` /
// `transformDOMQLEmotion` from `smbls` — symbols v3.14 does not export
// (emotion was replaced wholesale by the `@symbo.ls/css` atomic engine;
// nothing in the repo even depends on `@domql/emotion` any more). The
// binding resolved to `undefined` in the Parcel bundle and hard-failed the
// whole barrel under `node --test` / `bun test`. Proven unreachable before
// deletion: its only caller chain — canvas `ComponentThumbnailDashboard.js`
// ← `ComponentThumbnailUI.js` ← `Scene.js` ← `CanvasLegacyIframe.js` ←
// `CanvasLegacy.js` — is orphaned (none of those files is barrel-exported,
// so their DOMQL keys never register). See tickets/workspace.md.
export * from './notification.js'
export * from './config.js'
export * from './canvas-page.js'
export * from './send-request.js'
export * from './follow.js'
export * from './google-auth.js'
export * from './log.js'
export * from './shared-libraries.js'
export * from './test.js'
export * from './file-sidebar.js'
export * from './editor.js'
export * from './floating-panel.js'

export * from './crud/index.js'
export * from './depdencencies.js';
